//import { provider } from '../Config/configUSDC'
import { ethers } from "ethers";
import axios from "axios";
import { contractAddress, contractWithSigner} from "../Config/configUSDC";

const abiCoder = ethers.utils.defaultAbiCoder;

let paymentReferenceArray = [];
let allPaymentReferencesBlockNumberArray = [];
let redeemedInvoicesArray = [];
let paymentsToRedeemArray = [];

async function payOutERC20() {
    await contractWithSigner.payOutERC20Invoice(paymentsToRedeemArray);
}

const RPC_URL = `${process.env.REACT_APP_RPC_URL}`;
//


// (async () => {
//     const provider = new ethers.providers.JsonRpcProvider("http://127.0.0.1:8545");
//     const rawData = await provider.getLogs({
//         address: "0x2e670ADC7814568fAA618e6815b9C8a2FaCD181f",
//         topics: ["0x3949326165d95b8a403b9bbb410a566da35367dd971b51a8a331801a571147ed"] //payment event
//     }
      
//     );
//     console.log(filterId);
//   })();

export const redeemData = async () => {
   // const provider = new ethers.providers.JsonRpcProvider("http://127.0.0.1:8545");
    let rawData = await axios.post(RPC_URL, {
        jsonrpc: '2.0',
        id: 0,
        method: 'eth_getLogs',
        params: [{
            "fromBlock": "0x591E36",
            "toBlock": "latest",
            "address": contractAddress,
            "topics": ["0x160b9883c8416d313cc749bc5858db361276143105365a035258beace5bf3b3e"] //payment event

        }],
        headers: {
            'Content-Type': 'application/json',
        },
    })

    console.log(rawData);

    for (var i = 0; i < rawData.data.result.length; i++) {
        let txDataRaw = rawData.data.result[i].data;
        let txblockNumber = rawData.data.result[i].blockNumber;
        console.log("Tx block number:",txblockNumber);
        let decodedData = abiCoder.decode(["address", "address", "address", "uint", "uint", "uint", "bytes"], txDataRaw);
        console.log(decodedData);
        let txPaymentReference = decodedData[6];
        let txDueDateInSeconds = decodedData[4];
        let txDueDateInMiliseconds = Number(txDueDateInSeconds * 1000);
        let currentTimeInMiliseconds = Number(Date.now());
        console.log(txDueDateInMiliseconds);
        console.log(currentTimeInMiliseconds);
        
        if(currentTimeInMiliseconds > txDueDateInMiliseconds) {

            paymentReferenceArray.push(txPaymentReference);
            //console.log(paymentReferenceArray);
        
        }

        allPaymentReferencesBlockNumberArray.push({txPaymentReference, txblockNumber});
    };
    console.log("To be redeemed:",paymentReferenceArray);
    console.log("All payments tx ref and block number array:",allPaymentReferencesBlockNumberArray);
    // if(paymentReferenceArray.length > 0) {
    //     let tx = payOutERC20();
    //     let receipt = await provider.getTransactionReceipt(tx.hash);
    //     console.log(receipt);
    // }

    //get all the redeemed invoices

    const redeemedInvoices = await axios.post(RPC_URL, {
        jsonrpc: '2.0',
        id: 0,
        method: 'eth_getLogs',
        params: [{
            "fromBlock": "0x591E36",
            "toBlock": "latest",
            "address": contractAddress,
            "topics": ["0x3c77ae279df37c7ea5dd3a57f101c57dac95417ce9c24279d6ec87d9399c82d7"] //redeem event

        }],
        headers: {
            'Content-Type': 'application/json',
        },
    });
    console.log("Already redeemed:",redeemedInvoices);
    if(redeemedInvoices.data.result.length > 0) {
      
        for (let i = 0; i < redeemedInvoices.data.result.length; i++) {
            const txDataRedemeedInvoicesRaw = redeemedInvoices.data.result[i].data;
            //const txDataRedeemedBlockNumber = redeemedInvoices.data.result[i].blockNumber;
            const txDataRedeemedInvoices = abiCoder.decode(["address", "address", "address", "uint", "bytes", "uint"], txDataRedemeedInvoicesRaw);
            const txRedeemedPaymentReference = txDataRedeemedInvoices[4];
            redeemedInvoicesArray.push(txRedeemedPaymentReference);
        }
        console.log("Already redeemed:",redeemedInvoicesArray);
    } else{
        console.log("There are no invoices redeemed yet");
    }

    let blockNumberArray = [];

    for(let i = 0; i < allPaymentReferencesBlockNumberArray.length; i++) {
        if(redeemedInvoicesArray.includes(allPaymentReferencesBlockNumberArray[i].txPaymentReference)) {
            delete allPaymentReferencesBlockNumberArray[i];
            console.log("Deleted ",i,"from the array")
        }
    }
    console.log("allPaymentReferencesBlockNumberArray after deleting:",allPaymentReferencesBlockNumberArray);

    //get lowest block number:
    
    for (let i = 0; i < allPaymentReferencesBlockNumberArray.length; i++) {
        if(allPaymentReferencesBlockNumberArray[i] !== undefined) {
            blockNumberArray.push(Number(allPaymentReferencesBlockNumberArray[i].txblockNumber));
        }
        
    }
    console.log("block number array:",blockNumberArray);
    let minBlockNumber = Math.min(...blockNumberArray);
    console.log(minBlockNumber);

    for(let i = 0; i < paymentReferenceArray.length; i++) { //the references in this array are due
        console.log("Array of due references: ",paymentReferenceArray);
        if(!redeemedInvoicesArray.includes(paymentReferenceArray[i])) {
          paymentsToRedeemArray.push(paymentReferenceArray[i]);
          console.log("Pushed ",paymentReferenceArray[i],"to redeem array");
        }
    }
    console.log(paymentsToRedeemArray)

    if(paymentsToRedeemArray.length > 0) {
       payOutERC20(paymentsToRedeemArray)
    } else {
       console.log("No payments to redeem at this time");
    }

}
